export function isKeyboardEvent(e) {
    // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible. please refactor when possible.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const event = e;
    return e != null && (event.key != undefined || event.keyCode != undefined);
}
